export const isNode = false;




//////////////////
// WEBPACK FOOTER
// ./~/detect-node-es/esm/browser.js
// module id = 7954
// module chunks = 2